import { Controller } from '@hotwired/stimulus';

/**
 * OS Setup Skip Controller
 *
 * Fires the `os:setup_skipped` analytics event when the user clicks the
 * "Pas d'OS pour ce marché" card on the OS setup hub. Lets the default
 * link navigation proceed afterwards (no preventDefault) — analytics is
 * fire-and-forget; if the global tracker is missing the link still navigates.
 *
 * Values:
 * - contractId: Number — the contract whose OS setup is being skipped.
 *
 * Actions:
 * - fire: Click handler that emits the analytics event.
 *
 * @example
 *   <%= link_to project_contract_path(@project, @contract),
 *               data: {
 *                 controller: 'os-setup-skip',
 *                 action: 'click->os-setup-skip#fire',
 *                 os_setup_skip_contract_id_value: @contract.id
 *               } do %>
 *     ...
 *   <% end %>
 */
export default class extends Controller {
  static values = {
    contractId: Number,
  };

  fire() {
    if (typeof window.Jerico?.track === 'function') {
      window.Jerico.track('os:setup_skipped', {
        contract_id: this.contractIdValue,
      });
    }
    // If no global tracker is wired up, fail silently — the link still
    // navigates because we never call preventDefault.
  }
}
